<template>
<div class="chapter">
<div class="inner_page">
<p class="half"><a id="page_i"></a>Nazi Spies and Collaborators in Britain, 1939–1945</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?576887d5